import React from 'react';
import { Col, Row } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import ResponsavelLookup from 'src/lookups/colaborador';
import StatusApresentacaoLookup from 'src/lookups/status-apresentacao';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import { capitalizeFirstLetter } from 'src/utils/string';

class ApresentacaoSearch extends React.Component {
  render() {
    let { model, resources, intl } = this.props;

    return (
      <Row>
        <Col md={12}>
          <Input model={model.getModel('nome')} />
        </Col>
        <Col md={12}>
          <ItemOrganizacaoLookup
            multi
            model={{
              label: capitalizeFirstLetter(resources.areas),
              value: model.getModel('area').value,
              requestChange: model.getModel('area').requestChange,
            }}
            data={{ tiposIdSelecionaveis: [1, 2, 3] }}
          />
        </Col>
        <Col md={12}>
          <Checkbox
            model={{
              label: intl.formatMessage({ id: 'label.considerarAreasSubordinadas' }, { areas: resources.areas }),
              value: model.getModel('areasSubordinadas').value,
              requestChange: model.getModel('areasSubordinadas').requestChange,
            }}
            disabled={!model.getModel('area').value}
            style={{ marginTop: 8, marginBottom: 15 }}
          />
        </Col>
        <Col md={12}>
          <ResponsavelLookup
            multi
            model={{
              label: capitalizeFirstLetter(resources.responsaveis),
              value: model.getModel('responsaveis').value,
              requestChange: model.getModel('responsaveis').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <StatusApresentacaoLookup model={model.getModel('status')} />
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    configuracaoSistema: state.user.configuracao,
  };
}

export default injectIntl(connect(mapStateToProps)(ApresentacaoSearch));
